import React from 'react';
import { Flex } from 'antd';

import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { TextInputComponent } from 'baseComponents/TextInputComponent';

type AdminGenerateApiKeyFormProps = {
  apiKeyValue: string | null;
  onGenerateButtonClick: () => void;
  onCopyToClipboardButtonClick: () => void;
};

export const AdminGenerateApiKeyForm = (
  {
    apiKeyValue = null,
    onGenerateButtonClick,
    onCopyToClipboardButtonClick,
  }: AdminGenerateApiKeyFormProps,
) => {
  return (
    <div>
      <Flex vertical gap={16} style={{ padding: 2, marginTop: 20 }}>
        <TextInputComponent
          label='Api key'
          disabled={true}
          value={apiKeyValue || ''}
        />
      </Flex>
      <Flex gap={16} style={{ padding: 2, marginTop: 10 }}>
        <ButtonComponent
          appereance='primary'
          size='middle'
          label='Regenerate'
          onClick={onGenerateButtonClick}
          fullWidth
          style={{ maxWidth: 125 }}
        />
        <ButtonComponent
          appereance='secondary'
          size='middle'
          label='Copy key'
          disabled={!apiKeyValue}
          onClick={onCopyToClipboardButtonClick}
          fullWidth
          style={{ maxWidth: 125 }}
        />
      </Flex>
    </div>
  );
};
